import { computeColor as d, textColorsFallback as x, getBackgroundColorStyle as b, computeFont as h, textColors as f } from "@typedream/core";
import T from "classnames";
import { TEXT_MOBILE_BIG_CUTOFF as u, TEXT_MOBILE_BIG_PERCENT as k, TEXT_MOBILE_SMALL_CUTOFF as m, TEXT_MOBILE_SMALL_PERCENT as C } from "../constants.js";
import { text as L } from "./Text.css.js";
import { jsx as i, Fragment as B } from "react/jsx-runtime";
import { AnimatedText as S } from "./AnimatedText/AnimatedText.js";
function y(e) {
  const {
    attributes: t,
    children: o
  } = e;
  return /* @__PURE__ */ i("strong", {
    ...t,
    children: o
  });
}
function E(e) {
  const {
    attributes: t,
    children: o
  } = e;
  return /* @__PURE__ */ i("em", {
    ...t,
    children: o
  });
}
function F(e) {
  const {
    leaf: t,
    attributes: o,
    children: r
  } = e, a = d(t.color, x);
  return /* @__PURE__ */ i("u", {
    style: {
      textDecoration: "underline",
      textDecorationColor: a
    },
    ...o,
    children: r
  });
}
function _(e) {
  const {
    attributes: t,
    children: o
  } = e;
  return /* @__PURE__ */ i("s", {
    ...t,
    children: o
  });
}
function v(e) {
  const {
    attributes: t,
    children: o
  } = e;
  return /* @__PURE__ */ i("code", {
    ...t,
    children: o
  });
}
function I(e) {
  const {
    leaf: t,
    attributes: o,
    children: r
  } = e, a = t.lineHeight || void 0;
  let c = {};
  const l = t.fontSize || void 0;
  let n = l, s = a;
  n && (n = n > u ? k * n : n, n = n > m ? C * n : n, s = t.fontSize > u ? `${n + 10}px` : s, s = t.fontSize > m ? `${n + 5}px` : s), c = {
    ...b(t.background),
    color: d(t == null ? void 0 : t.color, x),
    fontFamily: h(t == null ? void 0 : t.fontFamily),
    fontWeight: t.fontWeight || void 0,
    letterSpacing: t.letterSpacing || void 0,
    "--font-size": l ? `${l}px` : void 0,
    "--mobile-font-size": n ? `${n}px` : void 0,
    "--line-height": a,
    "--mobile-line-height": s
  };
  const p = t.gradient && t.color ? {
    backgroundImage: d(t == null ? void 0 : t.color, f),
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    WebkitBoxDecorationBreak: "clone",
    backgroundRepeat: "no-repeat",
    marginRight: "-0.2em",
    paddingRight: "0.2em"
  } : void 0;
  return /* @__PURE__ */ i("span", {
    style: c,
    ...o,
    children: t.gradient && t.color ? /* @__PURE__ */ i("span", {
      style: p,
      children: r
    }) : r
  });
}
const g = {
  styled: I,
  italic: E,
  code: v,
  bold: y,
  underline: F,
  strikethrough: _
};
function z(e) {
  const {
    className: t,
    attributes: o,
    children: r
  } = e;
  return /* @__PURE__ */ i("span", {
    className: T(t, L),
    ...o,
    children: r
  });
}
function X(e) {
  const {
    leaf: t
  } = e, o = t.animation ? /* @__PURE__ */ i(S, {
    animation: t.animation ? {
      ...t.animation,
      words: [t.text, ...t.animation.words]
    } : void 0,
    style: t.gradient && t.color ? {
      backgroundImage: f[t.color],
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      WebkitBoxDecorationBreak: "clone",
      backgroundRepeat: "no-repeat"
    } : void 0
  }) : t.text, r = (c) => {
    if (c.length === 0)
      return /* @__PURE__ */ i(B, {
        children: o
      });
    const l = g[c[0]];
    return /* @__PURE__ */ i(l, {
      leaf: t,
      children: r(c.slice(1))
    });
  }, a = Object.keys(g).filter((c) => t.text !== "" && t[c] === !0);
  return /* @__PURE__ */ i(z, {
    ...e,
    children: r(a)
  });
}
export {
  y as BoldTextLeaf,
  v as CodeTextLeaf,
  E as ItalicTextLeaf,
  X as SerializeTextLeaf,
  _ as StrikethroughTextLeaf,
  I as StyledTextLeaf,
  z as TextLeaf,
  F as UnderlineTextLeaf
};
